export const MAX_MESSAGES = 50
export const RETRY_ATTEMPTS = 2
export const RETRY_DELAY = 1000